import Vue from '../../lib/utils/vue3compat/vue.js?vue3';
import { mapState } from '../../../../../node_modules/pinia/dist/pinia.mjs?vue3';
import { useDiffsView } from '../stores/diffs_view.js?vue3';
import { pinia } from '../../pinia/instance.js?vue3';
import HiddenFilesWarning from '../../diffs/components/hidden_files_warning.vue?vue3';

export function initHiddenFilesWarning(el) {
  // eslint-disable-next-line no-new
  new Vue({
    el,
    name: 'HiddenFilesWarningRoot',
    pinia,
    computed: {
      ...mapState(useDiffsView, ['overflow', 'totalFilesCount']),
    },
    render(h) {
      if (!this.overflow) return null;

      return h(HiddenFilesWarning, {
        props: {
          total: this.totalFilesCount,
          visible: this.overflow?.visibleCount,
          plainDiffPath: this.overflow?.diffPath,
          emailPatchPath: this.overflow?.emailPath,
        },
      });
    },
  });
}
